import imageQuizPreviewEmptyState from '@/assets/buzz/buzz-result-preview-empty-state.png';
import imageQuizPreviewBottombar from '@/assets/buzz/quiz_preview_bottombar.png';
import Constants from '@/Constants';
import { ApplicationState } from '@/store';
import PerfectScrollbar from 'perfect-scrollbar';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import _ from 'underscore';
import { ResultForm } from '../formConfig';
import './style.scss';

interface Props {
    formState: ResultForm;
    imageTempPath?: string;
}

const QuizResultPreviewScreen: React.FC<Props> = (props: Props) => {
    const { title, introduction, image, description, hint } = props.formState;
    const { imageTempPath } = props;

    const { strings } = useSelector((state: ApplicationState) => ({
        strings: state.locale.data,
    }));

    const isFormEmpty = () => {
        return _.isEmpty(title) && _.isEmpty(introduction) && _.isEmpty(image) && _.isEmpty(description) && _.isEmpty(hint);
    };

    const [perfectScrollbar, setPerfectScrollbar] = useState<PerfectScrollbar>();

    const quizRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        if (quizRef.current) setPerfectScrollbar(new PerfectScrollbar('#quiz-result-preview', { wheelPropagation: false }));
    }, [quizRef]);

    useEffect(() => {
        updatePerfectScrollbar();
    }, [title, introduction, image, description]);

    const updatePerfectScrollbar = () => {
        if (perfectScrollbar) {
            setTimeout(() => {
                perfectScrollbar.update();
            }, 500);
        }
    };

    return (
        <div className="quiz-result-preview-container">
            <div className={`quiz-result-preview-content ${isFormEmpty() ? 'empty-state' : ''}`}>
                {isFormEmpty() && <img src={imageQuizPreviewEmptyState}></img>}
                {!isFormEmpty() && (
                    <div className="quiz-result-preview" id="quiz-result-preview" ref={quizRef}>
                        {!_.isEmpty(introduction) && <div className="preview-introduction">{introduction}</div>}
                        {!_.isEmpty(title) && <div className="preview-title">{title}</div>}
                        {(!_.isEmpty(image) || !_.isEmpty(imageTempPath)) && (
                            <div className="preview-image">
                                <img src={imageTempPath ? imageTempPath : image} />
                            </div>
                        )}
                        {!_.isEmpty(description) && <div className="preview-description">{description}</div>}
                        {!_.isEmpty(hint) && (
                            <div className="preview-hint">
                                <span className="icon material-icons-outlined">{Constants.icons.STAR}</span>
                                <div>{strings.TIP}</div>
                                <div>{hint}</div>
                            </div>
                        )}
                    </div>
                )}
            </div>
            <div className="quiz-result-preview-bottombar">
                <img src={imageQuizPreviewBottombar}></img>
            </div>
        </div>
    );
};

export default QuizResultPreviewScreen;
